module.exports = __webpack_public_path__ + "img/google.8cb2924.png";